import { COLORS, colors } from '@constants/colors';
import { useMytaverse } from '@providers/MytaverseProvider';

export const useStyles = () => {
  const { appTheme } = useMytaverse();

  return {
    root: {
      p: 0,
      display: 'flex',
      alignItems: 'center',
      flexDirection: 'column',
      width: '100%',
    },

    permissionsWrapper: {
      display: 'flex',
      flexDirection: 'row',
      alignItems: 'center',
      '& img': {
        width: '100%',
        height: 'auto',
        maxWidth: 325,
      },
      mt: 4,
    },

    bottomSettings: {
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'space-between',
    },

    fontColor: {
      color: colors.white,
      fontWeight: 500,
      fontSize: 14,
      lineHeight: '20px',
      letterSpacing: '0.01em',
    },

    box: {
      mt: 2,
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'center',
      width: '100%',
      background: 'transparent',
      border: `1px solid ${colors.white}`,
      textTransform: 'none',
      borderRadius: '99px',
      padding: 0.5,
      // '&:hover': {
      //   backgroundColor: appTheme.mainColor,
      // },
    },
  };
};
